import { getAnalyticsActor, posthog } from './posthog'

const actions = [
    'detail_opened',
    'print_requested',
    'download_requested',
    'edit_opened',
] as const
const documents = [
    'invoice',
    'stock_out_note',
    'packing_slip',
    'box_label',
] as const
export type OrderFollowupAction = (typeof actions)[number]
export type OrderDocumentType = (typeof documents)[number]

/** Requests describe browser intent; they never claim a physical print succeeded. */
export function captureOrderFollowup(
    orderId: string,
    action: OrderFollowupAction,
    documentType?: OrderDocumentType,
    actorContext?: { actor: string; impersonating: boolean },
) {
    try {
        const actor = actorContext ?? getAnalyticsActor()
        if (!actor || !orderId || !actions.includes(action)) return
        if (documentType !== undefined && !documents.includes(documentType))
            return
        posthog.capture('order_followup_action', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            order_id: orderId,
            ...actor,
            ...(actorContext ? { distinct_id: actor.actor } : {}),
            action,
            stage:
                action === 'detail_opened' || action === 'edit_opened'
                    ? 'resolved'
                    : 'requested',
            route_template: '/orders/$orderId',
            ...(documentType ? { document_type: documentType } : {}),
        })
    } catch {
        // Analytics must never interrupt document actions or navigation.
    }
}
